import queryActionFactory from 'common/actions/queryActionFactory';
import DataV2 from 'common/DataV2';

import type { Post } from 'common/api/resources/posts';
import type { Dispatch } from 'redux-connect';

export type QueryParams = {
  ideaID: string;
};

const postsActions = queryActionFactory<Post, QueryParams>('ideaPost', DataV2.queries.ideaPost);

export const {
  // query helpers
  getQueryKey,

  // action creators
  invalidateQueries: invalidateIdeaPost,
  loadQuery: loadIdeaPost,
  reloadQuery: reloadIdeaPost,

  // action types
  BulkLoadedType,
  BulkRemoveType,
  RequestType,
  RequestMoreType,
  LoadedType,
  LoadedMoreType,
  ErrorType,
  InvalidateType,
} = postsActions;

export const upsertIdeaPosts = (posts: Post[]) => {
  return async (dispatch: Dispatch): Promise<void> => {
    await dispatch(
      postsActions.bulkLoadedAction(
        posts
          .filter((post) => !!post.ideaID)
          .map((post) => ({
            queryKey: getQueryKey({ ideaID: post.ideaID! }),
            queryParams: { ideaID: post.ideaID! },
            queryResponse: {
              cursor: null,
              items: [post],
              hasNextPage: false,
            },
          })),
      ),
    );
  };
};

export const removeIdeaPosts = (posts: Post[]) => {
  return async (dispatch: Dispatch): Promise<void> => {
    await dispatch(
      postsActions.bulkRemoveAction(
        posts.map((post) => ({
          queryKey: getQueryKey({ ideaID: post.ideaID! }),
          queryParams: { ideaID: post.ideaID! },
          items: [post],
        })),
      ),
    );
  };
};
